import { Reducer, useReducer } from "react";
import { getPrice } from "modules/cart/services/getPrice";
import {
  CartActionType,
  CartItem,
  DispatchAction,
  Action,
  Payload,
} from "modules/cart/types/cart";
import { AddCartMethod } from "../types/add-cart-methods";
import { AuthError } from "modules/authentication/types/form-login-types";
// import { RefreshCw } from "lucide-react";
import { getUpdates } from "modules/product/services/getUpdates";
// import { sendAddToCart } from "utils/analytics";

export const useReducerCartMiddleware = (
  reducer: Reducer<Array<CartItem>, DispatchAction>,
  cartInitialState: Array<CartItem>,
) => {
  const [state, dispatch] = useReducer(reducer, cartInitialState);
  const defaultMethod: AddCartMethod = "SAME";

  const dispatchMiddleware = async ({ type, payload }: Action) => {
    if (
      type === CartActionType.AddDeletefromCart &&
      payload &&
      "sku" in payload &&
      "quantity" in payload
    ) {
      try {
        const productData =
          payload.quantity > 0
            ? await getPrice(
                payload.sku,
                payload.quantity,
                payload.method ?? defaultMethod,
              )
            : {
                id: payload.id,
                brand: "",
                slug: "",
                name: payload.name,
                category_id: payload.category_id,
                price_component: [],
                method: defaultMethod,
              };
        // sendAddToCart({
        //     id:productData.id,
        //     brand:productData.brand,
        //     slug:productData.slug,
        //     name:productData.name,
        //     price_component:productData.price_component,
        //     method:payload.method ?? defaultMethod
        // } as CartItem);

        dispatch({
          type: type,
          payload: {
            product: {
              ...productData,
              // If a placeholder id was provided (linked items), preserve it
              // so the reducer can find and replace the placeholder by id.
              id: payload.id ?? productData.id,
              name: payload.name ?? "",
              category_id: payload.category_id,
              is_ai_resolved: (payload as Payload).is_ai_resolved,
              raw_description: (payload as Payload).raw_description,
              productDecision: (payload as Payload).productDecision,
              alternativeCandidates: (payload as Payload).alternativeCandidates,
            },
          },
        });
      } catch (error) {
        if (error instanceof AuthError) {
        }
      }
    }
    // if(type === CartActionType.bulkAddToCart && payload && Array.isArray(payload)){
    //     console.log("Middleware bulkAddToCart", payload);
    //     payload.forEach(item => {
    //         sendAddToCart({
    //             id:item.id,
    //             brand:"",
    //             slug:"",
    //             name:item.name ?? "",
    //             price_component:[],
    //             method:item.method ?? defaultMethod
    //         } as CartItem);
    //     }
    //     );
    //     try{
    //         const productBulkData = (payload.length > 0) ? await getBulkData(payload.map(item => item.sku), payload.map(item => item.quantity), payload.map(item => item.method ?? defaultMethod)):[
    //         {    id:0,
    //             brand:"",
    //             slug:"",
    //             name:"",
    //             price_component:[],
    //             method:defaultMethod}]
    //         dispatch({
    //             type:type,
    //             payloadArray:productBulkData});

    //     }catch(e){
    //         console.error("Error in bulkAddToCart middleware", e);
    //     }
    // }

    if (
      type === CartActionType.SwapCartItem &&
      payload &&
      "sourceItemId" in payload &&
      "replacement" in payload
    ) {
      try {
        const replacement = payload.replacement;
        const productData =
          replacement.quantity > 0
            ? await getPrice(
                replacement.sku,
                replacement.quantity,
                replacement.method ?? defaultMethod,
              )
            : {
                id: replacement.id,
                brand: "",
                slug: "",
                name: replacement.name,
                category_id: replacement.category_id,
                price_component: [],
                method: defaultMethod,
              };

        dispatch({
          type: type,
          payload: {
            sourceItemId: payload.sourceItemId,
            product: {
              ...productData,
              // The canonical product id comes from getPrice; never override it
              // with the hashed sku used to fetch the price.
              id: productData.id,
              name: replacement.name ?? "",
              category_id: replacement.category_id,
              is_ai_resolved: (replacement as Payload).is_ai_resolved,
              raw_description: (replacement as Payload).raw_description,
              productDecision: (replacement as Payload).productDecision
                ? {
                    ...(replacement as Payload).productDecision!,
                    productId: productData.id,
                  }
                : undefined,
              alternativeCandidates: (replacement as Payload)
                .alternativeCandidates,
            },
          },
        });
      } catch (error) {
        if (error instanceof AuthError) {
        }
      }
    }

    if (type === CartActionType.RemoveFromCart && payload && "id" in payload) {
      // sendAddToCart({
      //     id:payload.id,
      //     brand:"",
      //     slug:"",
      //     name:payload.name,
      //     price_component:[],
      //     method:payload.method ?? defaultMethod
      // } as CartItem);
      dispatch({
        type: type,
        payload: {
          product: {
            id: payload.id,
            slug: "",
            brand: "",
            name: "",
            category_id: 0,
            method: defaultMethod,
            price_component: [],
          },
        },
      });
    }
    if (type === CartActionType.ClearCart) {
      dispatch({
        type: type,
      });
    }
    if (
      type === CartActionType.RefreshCart &&
      payload &&
      Array.isArray(payload)
    ) {
      dispatch({
        type: type,
        payload: { cart: payload },
      });
    }

    if (
      type === CartActionType.Recalculate &&
      payload &&
      "sku" in payload &&
      "quantity" in payload
    ) {
      try {
        const productData =
          payload.quantity > 0
            ? await getPrice(
                payload.sku,
                payload.quantity,
                payload.method ?? defaultMethod,
              )
            : {
                id: payload.id,
                brand: "",
                slug: "",
                name: "",
                category_id: payload.category_id,
                price_component: [],
                method: defaultMethod,
              };

        dispatch({
          type: type,
          payload: {
            product: {
              ...productData,
              category_id: payload.category_id,
              // method:payload.method
            },
          },
        });
      } catch (error) {
        if (error instanceof AuthError) {
        } else {
        }
      }
    }
    if (type === CartActionType.ReplaceCart && payload && "cart" in payload) {
      dispatch({
        type: type,
        payload: {
          cart: payload.cart,
        },
      });
    }
    if (
      type === CartActionType.Validating &&
      payload &&
      "name" in payload &&
      "quantity" in payload
    ) {
      try {
        // toast({
        //     title: "Validando la disponibilidad del producto",
        //     description: <p>{payload.name}</p>,
        //     action:<span className=""><RefreshCw id="refresh" className="h-6 w-6"/></span>
        // });
        const productUpdates = await getUpdates(
          payload.id,
          payload.method ?? defaultMethod,
        );
        return {
          isOpen: true,
          productUpdates: productUpdates,
        };
      } catch (error) {
        if (error instanceof Error && error.name !== "AbortError") {
          if (error instanceof AuthError) {
            // toast({
            //     variant:"destructive",
            //     title:"Error",
            //     description:"Tú sesión ha expirado, por favor vuelve a iniciar sesión",
            // })
          } else {
            // toast({
            // variant:"destructive",
            // title:"Error",
            // description:"Ha ocurrido un error validando el producto, intentaremos más tarde",
            // })
          }
        }
      }
    }

    if (
      type === CartActionType.SetDecision &&
      payload &&
      "id" in payload &&
      "productDecision" in payload &&
      payload.productDecision
    ) {
      dispatch({
        type,
        payload: {
          id: payload.id,
          productDecision: payload.productDecision,
        },
      });
    }
  };
  return [state, dispatchMiddleware] as const;
};
